import ScrollToTop from '../Components/ScrollToTop';
import HeroSection from '../Components/HeroSection/index';
import DecoreMasonry from '../Components/Masonry/DecoreMasonry'
import Footer from '../Components/Footer/Footer';

const Gallery = () => {
  return (
    <>
        <ScrollToTop />
        <HeroSection /> 
        <DecoreMasonry />
        <Footer />
    </>
  )
}

export default Gallery